import { API } from 'aws-amplify';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import moment from 'moment';
import { sortString } from '../elasticSearch/sortScripts';
import { UTC } from '../infrastructure/constants/common';
import { Party, PartyType } from '../types/Party';

export function getAllPartiesNew(
  order,
  filterData,
  LastEvaluatedKey,
  getAll = false
) {
  let query: Record<string, unknown> = { match_all: {} };

  if (filterData) {
    const terms: Record<string, unknown>[] = [];

    if (filterData.location.length > 0) {
      terms.push({
        term: { 'partyLocation.address.keyword': filterData.location },
      });
    }
    if (filterData.from && filterData.from !== '') {
      const fromdate = moment.tz(filterData.from, UTC).hour(1).toISOString();
      terms.push({ range: { startDate: { gte: fromdate } } });
    }
    if (filterData.to && filterData.to !== '') {
      const todate = moment.tz(filterData.to, UTC).hour(23).toISOString();
      terms.push({ range: { endDate: { lte: todate } } });
    }
    if (filterData.name.length >= 3) {
      terms.push({ match_phrase_prefix: { partyName: filterData.name } });
    }
    if (filterData.inviteCode.length >= 3) {
      terms.push({
        match_phrase_prefix: { inviteCode: filterData.inviteCode },
      });
    }

    if (filterData.partyStatus) {
      terms.push({
        match_phrase_prefix: { partyStatus: filterData.partyStatus },
      });
    }

    if (filterData.partyType) {
      terms.push({
        match_phrase: { partyType: filterData.partyType },
      });
    }

    if (terms.length > 0) {
      query = { bool: { must: terms } };
    }
  }

  const property = order.isString ? `${order.name}.keyword` : order.name;
  let srt;
  if (
    property === 'partyLocation.address.keyword' ||
    property === 'partyName.keyword'
  ) {
    srt = sortString(order, property);
  } else {
    srt = [{ [property]: order.up ? 'asc' : 'desc' }];
  }
  return API.post('party', '/parties/adminSearch', {
    body: {
      from: LastEvaluatedKey,
      size: getAll ? 10000 : 25,
      index: 'bach-parties',
      sort: srt,
      query,
    },
  });
}

export function getAllParties(LastEvaluatedKey, concierge) {
  let body = { concierge };
  if (LastEvaluatedKey !== null) {
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    body = { ...body, LastEvaluatedKey };
  }
  return API.post('party', '/parties/getByPage', { body });
}

export function getByUser() {
  // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
  // @ts-ignore
  return API.get('party', '/parties/getByUser');
}

export function searchByName(name) {
  // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
  // @ts-ignore
  return API.get('party', `/parties/search/name/${name}`);
}

export function getByCode(code) {
  // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
  // @ts-ignore
  return API.get('party', `/parties/getByCode/${code}`);
}
export function getById(id): Promise<Party> {
  // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
  // @ts-ignore
  return API.get('party', `/parties/getById/${id}`);
}

export function updatePartyMember(member) {
  return API.put('party', '/parties/updateMember', { body: { ...member } });
}

export function getEventsByParty(partyId) {
  // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
  // @ts-ignore
  return API.get('party', `/events/getByParty/${partyId}`);
}

export function getExpensesByParty(partyId) {
  // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
  // @ts-ignore
  return API.get('party', `/expenses/getExpensesByPartyId/${partyId}`);
}

export function setConcierge(partyId, conciergeId, conciergeName) {
  return API.put('party', '/parties/setConcierge', {
    body: { partyId, conciergeId, conciergeName },
  });
}

export function getMemberStatusFromParty(partyId, memberId) {
  // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
  // @ts-ignore
  return API.get('party', `/accounting/party/${partyId}/member/${memberId}`);
}

export function deactivateParty(partyId) {
  // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
  // @ts-ignore
  return API.post('party', `/parties/${partyId}/deactivate`);
}

export function activateParty(partyId) {
  // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
  // @ts-ignore
  return API.post('party', `/parties/${partyId}/activate`);
}

export function removeMemberFromParty(partyId, memberId, memberToAssign) {
  return API.put('party', `/parties/${partyId}/members/${memberId}/leave`, {
    body: memberToAssign,
  });
}

export function deleteConcierge(partyId) {
  return API.put('party', '/parties/deleteConcierge', { body: { partyId } });
}

export function getEventsById(eventid) {
  // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
  // @ts-ignore
  return API.get('party', `/events/getById/${eventid}`);
}

export function createEvent(event) {
  return API.post('party', '/events/create', { body: { ...event } });
}

export function updateEvent(event) {
  return API.put('party', '/events/update', { body: { ...event } });
}

export function deleteEvent(partyId, eventId) {
  return API.del('party', '/events/delete', { body: { partyId, eventId } });
}

export function getDefaultImagesForEvent() {
  // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
  // @ts-ignore
  return API.get('party', '/events/config/default-images');
}

export async function getBookMarkedByPartyId(partyId) {
  const response = await API.get('party', `/favorites/party/${partyId}`, {});
  return response.map(fav => ({
    activityId: fav.activityId,
    createdAt: fav.createdAt,
    activity: {
      title: fav.title,
    },
    creator: {
      memberName: (fav.savedBy || [])[0]?.memberName,
    },
  }));
}

export function getPollsByPartyId(partyId) {
  // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
  // @ts-ignore
  return API.get('party', `/polls/getByParty/${partyId}`);
}

export function getPartyTypes(): Promise<PartyType[]> {
  return API.get('party', '/parties/types', {});
}
